import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Tv, Radio } from 'lucide-react';

/** Stream History detail dialog — the existing "Recent Live Streams"
 * placeholder rows and empty state, moved here unchanged. No completed
 * live sessions are invented. */
export default function LiveStreamHistoryDialog({ open, onOpenChange, sessionLabel }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#14171F] border-white/10 sm:max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="live-stream-history-dialog">
        <DialogHeader><DialogTitle className="text-white">Stream History</DialogTitle></DialogHeader>
        <p className="text-xs text-[#8A93A6] -mt-3">Showing: {sessionLabel}</p>

        <Card className="glass border-white/5">
          <CardHeader className="pb-3">
            <CardTitle className="text-base">Recent Live Streams</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3 mb-6">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex items-center gap-4 p-3 rounded-lg bg-white/[0.02] border border-white/5">
                  <div className="w-9 h-9 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
                    <Tv className="h-4 w-4 text-[#3A3F4B]" />
                  </div>
                  <div className="flex-1 space-y-1.5">
                    <div className="h-3 w-32 bg-white/5 rounded" />
                    <div className="h-2 w-20 bg-white/[0.03] rounded" />
                  </div>
                  <div className="h-3 w-16 bg-white/5 rounded" />
                </div>
              ))}
            </div>

            <div className="text-center py-4">
              <Radio className="h-8 w-8 text-[#3A3F4B] mx-auto mb-3" />
              <p className="text-sm text-[#8A93A6]">No live stream data yet</p>
              <p className="text-xs text-[#555E6E] mt-1">Analytics will appear after your first live session</p>
            </div>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
}
